import { render, staticRenderFns } from "./TargetUserWarningModal.vue?vue&type=template&id=4a250523&scoped=true"
import script from "./TargetUserWarningModal.vue?vue&type=script&lang=js"
export * from "./TargetUserWarningModal.vue?vue&type=script&lang=js"
import style0 from "./TargetUserWarningModal.vue?vue&type=style&index=0&id=4a250523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a250523",
  null
  
)

export default component.exports